import React from 'react';
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
  Grid,
} from '@mui/material';
import ActionButtonsFormularioAgricultura from 'components/forms/ActionButtonsFormularioAgricultura';
import ComponentTipoDecreto from 'components/forms/ComponentTipoDecreto';
import { ContainerForm } from 'components/shared/container_form';
import InputComLabel from '../../../../../../components/shared/custom_input_label';
import { useFormularioSecretariaMunicipalAgriculturaStore } from '../../../../../../stores/forms/formularioAgricultura.store';

const Step5: React.FC = () => {
  const { formulario, setPartialForm } =
    useFormularioSecretariaMunicipalAgriculturaStore();

  // Lista de estruturas disponíveis
  const estruturas = [
    {
      label: 'Prédio próprio',
      key: 'possui_predio_proprio',
      qtdKey: 'quantidade_predio_proprio',
    },
    { label: 'Sala', key: 'possui_salas', qtdKey: 'quantidade_salas' },
    {
      label: 'Auditório',
      key: 'possui_auditorio',
      qtdKey: 'quantidade_auditorio',
    },
    {
      label: 'Computador de mesa',
      key: 'possui_computador',
      qtdKey: 'quantidade_computador',
    },
    {
      label: 'Notebook',
      key: 'possui_notebook',
      qtdKey: 'quantidade_notebook',
    },
    { label: 'Tablet', key: 'possui_tablet', qtdKey: 'quantidade_tablet' },
    {
      label: 'Impressora',
      key: 'possui_impressora',
      qtdKey: 'quantidade_impressora',
    },
    {
      label: 'Receptor GPS (GNSS) de navegação',
      key: 'possui_receptor_gps_navegacao',
      qtdKey: 'quantidade_receptor_gps_navegacao',
    },
    {
      label: 'Receptor GPS (GNSS) geodésico',
      key: 'possui_receptor_gps_geodesico',
      qtdKey: 'quantidade_receptor_gps_geodesico',
    },
    {
      label: 'Equipamento para coleta de solo',
      key: 'possui_equipamento_coleta_solo',
      qtdKey: 'quantidade_equipamento_coleta_solo',
    },
    {
      label: 'Veículo tipo popular',
      key: 'possui_veiculo_popular',
      qtdKey: 'quantidade_veiculo_popular',
    },
    {
      label: 'Veículo tipo camionete',
      key: 'possui_veiculo_caminhonete',
      qtdKey: 'quantidade_veiculo_caminhonete',
    },
    {
      label: 'Veículo tipo SUV',
      key: 'possui_veiculo_suv',
      qtdKey: 'quantidade_veiculo_suv',
    },
    {
      label: 'Motocicleta',
      key: 'possui_veiculo_motocicleta',
      qtdKey: 'quantidade_veiculo_motocicleta',
    },
    {
      label: 'Caminhão caçamba',
      key: 'possui_caminhao_cacamba',
      qtdKey: 'quantidade_caminhao_cacamba',
    },
    {
      label: 'Caminhão baú sem refrigeração',
      key: 'possui_caminhao_bau_sem_refrigeracao',
      qtdKey: 'quantidade_caminhao_bau_sem_refrigeracao',
    },
    {
      label: 'Caminhão baú refrigerado',
      key: 'possui_caminhao_bau_refrigerado',
      qtdKey: 'quantidade_caminhao_bau_refrigerado',
    },
    {
      label: 'Caminhão com tanque isotérmico para transporte de leite',
      key: 'possui_caminhao_com_tanque_isotermico',
      qtdKey: 'quantidade_caminhao_com_tanque_isotermico',
    },
    {
      label: 'Caminhão carga seca',
      key: 'possui_caminhao_carga_seca',
      qtdKey: 'quantidade_caminhao_carga_seca',
    },
    {
      label: 'Trator de 14 CV (micro-trator)',
      key: 'possui_trator_14cv',
      qtdKey: 'quantidade_trator_14cv',
    },
    {
      label: 'Trator de 50 CV',
      key: 'possui_trator_50cv',
      qtdKey: 'quantidade_trator_50cv',
    },
    {
      label: 'Trator de 75 CV',
      key: 'possui_trator_75cv',
      qtdKey: 'quantidade_trator_75cv',
    },
    {
      label: 'Trator de 110 CV',
      key: 'possui_trator_110cv',
      qtdKey: 'quantidade_trator_110cv',
    },
    {
      label: 'Implementos agrícolas diversos',
      key: 'possui_implementos_agricolas_diversos',
      qtdKey: 'quantidade_implementos_agricolas_diversos',
    },
    {
      label: 'Retroescavadeira',
      key: 'retroescavadeira',
      qtdKey: 'quantidade_retroescavadeira',
    },
    {
      label: 'Escavadeira hidráulica',
      key: 'escavadeira_hidraulica',
      qtdKey: 'quantidade_escavadeira_hidraulica',
    },
    {
      label: 'Pá carregadeira',
      key: 'pa_carregadeira',
      qtdKey: 'quantidade_pa_carregadeira',
    },
    {
      label: 'Viveiro para produção de mudas diversas',
      key: 'viveiro_producao_mudas',
      qtdKey: 'quantidade_viveiro_producao_mudas',
    },
  ];

  // Verificar se pelo menos uma estrutura está selecionada
  const pelomenosUmaEstruturaSelecionada = estruturas.some(
    (estrutura) => (formulario as any)?.[estrutura.key] === true,
  );

  // Ano referência (automático)
  const anoAtual = new Date().getFullYear();

  // Validações dos campos obrigatórios
  const validarCamposObrigatorios = () => {
    // Pelo menos uma estrutura deve estar selecionada
    if (!pelomenosUmaEstruturaSelecionada) return false;

    // A pergunta sobre instrumento legal é obrigatória
    if (
      formulario?.instrumento_legal_manutencao_agricola === null ||
      formulario?.instrumento_legal_manutencao_agricola === undefined
    ) {
      return false;
    }

    // Se respondeu "Sim" para instrumento legal, as perguntas 4, 5 e 6 são obrigatórias
    if (formulario?.instrumento_legal_manutencao_agricola === true) {
      // Tipo de publicação obrigatório
      if (!formulario?.tipo_publicacao_instrumento_legal_manutencao_agricola)
        return false;

      // Número da publicação obrigatório
      if (
        !formulario?.numero_publicacao_instrumento_legal_manutencao_agricola?.trim()
      )
        return false;

      // Data da publicação obrigatória
      if (!formulario?.data_publicacao_instrumento_legal_manutencao_agricola)
        return false;
    }

    return true;
  };

  const formularioInativo = validarCamposObrigatorios();

  const handleEstrutura = (key: string, checked: boolean) => {
    setPartialForm(key as any, checked);

    // Se desmarcar, limpar a quantidade com null
    if (!checked) {
      const estrutura = estruturas.find((e) => e.key === key);
      if (estrutura) {
        setPartialForm(estrutura.qtdKey as any, null);
      }
    }
  };

  const handleQuantidade = (qtdKey: string, valor: string) => {
    // Permitir apenas números
    const valorNumerico = valor.replace(/\D/g, '');

    // Se vazio, salvar como null, senão como número
    const valorFinal = valorNumerico === '' ? null : Number(valorNumerico);
    setPartialForm(qtdKey as any, valorFinal);
  };

  const checkRadio = (
    e: React.ChangeEvent<HTMLInputElement>,
    campo: string,
  ) => {
    const valor = e.target.value;
    const valorBoolean = valor === 'true' ? true : false;
    setPartialForm(campo as any, valorBoolean);

    // Se mudou para "Não", limpar os campos relacionados
    if (valorBoolean === false) {
      setPartialForm(
        'tipo_publicacao_instrumento_legal_manutencao_agricola' as any,
        '',
      );
      setPartialForm(
        'numero_publicacao_instrumento_legal_manutencao_agricola' as any,
        '',
      );
      setPartialForm(
        'data_publicacao_instrumento_legal_manutencao_agricola' as any,
        '',
      );
    }

  };

  return (
    <>
      <ContainerForm title='Estrutura'>
        <Box
          sx={{ borderBottom: 1, borderColor: 'divider' }}
          gap={4}
          display={'flex'}
          flexDirection={'column'}
        >
          {/* 1. Estrutura da Secretaria */}
          <FormControl>
            <FormLabel
              id='estrutura-label'
              sx={{
                color: '#333',
                marginBottom: 2,
                fontWeight: 'bold',
              }}
            >
              1. De qual estrutura a Secretaria/Órgão municipal de agricultura
              dispõe para executar as suas atividades, ações, projetos e/ou
              programas?
            </FormLabel>

            <Grid container spacing={2}>
              {estruturas.map((estrutura) => (
                <Grid item xs={6} key={estrutura.key}>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      maxWidth: '800px',
                    }}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={
                            (formulario as any)?.[estrutura.key] === true
                          }
                          onChange={(e) =>
                            handleEstrutura(estrutura.key, e.target.checked)
                          }
                        />
                      }
                      label={estrutura.label}
                      sx={{
                        flex: 1,
                        mr: 3,
                      }}
                    />
                    <TextField
                      size='small'
                      placeholder='Quantidade'
                      value={
                        (formulario as any)?.[estrutura.qtdKey]?.toString() ||
                        ''
                      }
                      onChange={(e) =>
                        handleQuantidade(estrutura.qtdKey, e.target.value)
                      }
                      disabled={!(formulario as any)?.[estrutura.key]}
                      sx={{
                        width: '140px',
                        '& .MuiOutlinedInput-root': {
                          '& fieldset': {
                            borderColor: '#e0e0e0',
                          },
                          '&:hover fieldset': {
                            borderColor: '#1976d2',
                          },
                        },
                      }}
                      type='text'
                      inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                    />
                  </Box>
                </Grid>
              ))}
            </Grid>
          </FormControl>

          {/* 2. Ano Referência (automático) */}
          <Box sx={{ mt: 3 }}>
            <FormLabel sx={{ color: '#333', fontWeight: 'bold' }}>
              2. Ano Referência do Questionário: {anoAtual}
            </FormLabel>
          </Box>

          {/* 3. Instrumento legal */}
          <FormControl sx={{ mt: 3 }}>
            <FormLabel
              id='instrumento-legal-label'
              sx={{
                color: '#333',
                fontWeight: 'bold',
              }}
            >
              3. O município possui instrumento legal ou normativo que trata da
              gestão, guarda e manutenção de máquinas e implementos agrícolas?
            </FormLabel>

            <RadioGroup
              aria-labelledby='instrumento-legal-label'
              value={
                formulario?.instrumento_legal_manutencao_agricola?.toString() ||
                ''
              }
              onChange={(e) =>
                checkRadio(e, 'instrumento_legal_manutencao_agricola')
              }
            >
              <FormControlLabel value='true' control={<Radio />} label='Sim' />
              <FormControlLabel value='false' control={<Radio />} label='Não' />
            </RadioGroup>
          </FormControl>

          {/* 4, 5, 6 - Só aparecem se respondeu Sim */}
          {formulario?.instrumento_legal_manutencao_agricola === true && (
            <>
              {/* 4. Tipo de publicação */}
              <ComponentTipoDecreto
                labelText='4. Informe o tipo da publicação:'
                value={
                  formulario?.tipo_publicacao_instrumento_legal_manutencao_agricola ||
                  ''
                }
                onChange={(value) =>
                  setPartialForm(
                    'tipo_publicacao_instrumento_legal_manutencao_agricola',
                    value,
                  )
                }
              />

              {/* 5. Número da publicação */}
              <InputComLabel
                valor={
                  formulario?.numero_publicacao_instrumento_legal_manutencao_agricola ||
                  ''
                }
                setValor={(valor) =>
                  setPartialForm(
                    'numero_publicacao_instrumento_legal_manutencao_agricola',
                    valor,
                  )
                }
                labelTexto='5. Número e data de publicação do instrumento legal ou normativo que trata da gestão, guarda e manutenção de máquinas e implementos agrícolas:'
                placeholder='Digite o número da publicação'
                required
              />

              {/* 6. Data da publicação */}
              <InputComLabel
                valor={
                  formulario?.data_publicacao_instrumento_legal_manutencao_agricola ||
                  ''
                }
                setValor={(valor) =>
                  setPartialForm(
                    'data_publicacao_instrumento_legal_manutencao_agricola',
                    valor,
                  )
                }
                labelTexto='6. Data da publicação do instrumento legal ou normativo que trata da gestão, guarda e manutenção de máquinas e implementos agrícolas:'
                placeholder='dd/mm/aaaa'
                type='date'
                required
              />
            </>
          )}
        </Box>
        <ActionButtonsFormularioAgricultura disabled={!formularioInativo} />
      </ContainerForm>
    </>
  );
};

export default Step5;
